import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { githubApi } from '../services/githubApi';
import { BusinessCard as BusinessCardType } from '../types';
import BusinessCard from '../components/BusinessCard';
import Loading from '../components/Loading';
import Error from '../components/Error';

const CardView: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [card, setCard] = useState<BusinessCardType | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCard = async () => {
      if (!slug) {
        setError('Card not found');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError('');
        
        const result = await githubApi.fetchCard(slug);
        
        if (result.success && result.data) {
          setCard(result.data);
        } else {
          setError(result.error || 'Card not found');
        }
      } catch (err) {
        setError('Failed to load card');
        console.error('Error fetching card:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCard();
  }, [slug]);

  const handleRetry = () => {
    setLoading(true);
    setError('');
    // Refetch the card
    if (slug) {
      githubApi.fetchCard(slug).then(result => {
        if (result.success && result.data) {
          setCard(result.data);
        } else {
          setError(result.error || 'Card not found');
        }
        setLoading(false);
      }).catch(err => {
        setError('Failed to load card');
        setLoading(false);
      });
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Loading fullScreen text="Loading card..." />
      </div>
    );
  }

  if (error || !card) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Error 
          message={error || 'Card not found'} 
          onRetry={handleRetry}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {card.name}
          </h1>
          <p className="text-gray-600">
            {card.position} at {card.company}
          </p>
        </div> */}

        <div className="flex justify-center">
          <BusinessCard card={card} className="w-full max-w-2xl" />
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            Powered by {process.env.REACT_APP_COMPANY_NAME || 'Prime Utility Company'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardView; 